<template>
    <div id="video-hero" class="d-flex flex-column mx-auto">

        <div class="video-container">
            <img src="../../assets/imgs/landing/clip-frame.png" alt="" class="img-fluid">
            <iframe src="https://www.youtube.com/embed/GHbbG9AxQYw?loop=1&playlist=GHbbG9AxQYw"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope;"
                    frameborder="0" allowfullscreen></iframe>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Video"
    }
</script>

<style scoped>

</style>